
import { Component, Mixins, Vue } from "vue-property-decorator";
import { filter } from "lodash";

import {
  sendRaiseHand,
  sendUnraiseHand,
  sendHandReset
} from "@/services/meeting/messaging";
import { HandRaise } from "@/interfaces/meeting/details";
import SoundMixin from "@/mixins/SoundMixin.vue";

@Component
export default class RaiseHandMixin extends Mixins<SoundMixin>(SoundMixin) {
  // To determine whether a user has raised hand.
  userHasRaisedHand = false;
  handRaiseList: HandRaise[] = [];

  toggleHandRaise(userId: string, name: string) {
    const isHandRaise = !this.userHasRaisedHand;
    this.userHasRaisedHand = isHandRaise;

    if (userId && name) {
      const details: HandRaise = { userId, name };
      if (isHandRaise) {
        sendRaiseHand(details);
      } else {
        sendUnraiseHand(details);
      }
    }
  }

  clearRaisedHands() {
    // Clear local hand raise list
    this.handRaiseList = [];
    sendHandReset();
  }

  get raisedHandNames() {
    const names = this.handRaiseList.map(handRaise => handRaise.name);
    // Return unique users.
    return names ? Array.from(new Set(names)) : [];
  }

  get raiseHandIconColor() {
    return this.userHasRaisedHand ? "success" : "white";
  }

  get raiseHandButtonText() {
    return this.userHasRaisedHand ? "Unraise hand" : "Raise hand";
  }

  get raiseHandTextClass() {
    return this.userHasRaisedHand ? "success--text" : "";
  }

  get hasReceivedHandRaised() {
    return Boolean(this.handRaiseList.length);
  }

  // START - Handlers
  onRaiseHand(handRaise: HandRaise) {
    this.handRaiseList.push(handRaise);
    this.playNotification();
  }

  onUnraiseHand(handRaise: HandRaise) {
    this.handRaiseList = filter(
      this.handRaiseList,
      object => object.userId !== handRaise.userId
    );
  }

  onHandReset() {
    this.userHasRaisedHand = false;
  }
  // END - Handlers
}
